export const defaultTheme = {
  theme: {
    light: {
      text_color: '#222222',
      primary_color: '#cca257',
      primary_text_color: undefined,
      secondary_color: '#424242',
      drawer_color: '#333333',
      drawer_text_color: '#FFFFFF',
      data_table_header_color: undefined,
      data_table_header_text_color: undefined,
      app_bar_color: '#f5f5f5',
      app_bar_text_color: '#cca257',
    },
    dark: {
      text_color: '#FFFFFF',
      primary_color: '#cca257',
      primary_text_color: undefined,
      secondary_color: '#cca257',
      drawer_color: '#1e1e1e',
      drawer_text_color: '#FFFFFF',
      data_table_header_color: undefined,
      data_table_header_text_color: undefined,
      app_bar_color: '#1e1e1e',
      app_bar_text_color: '#FFFFFF',
    },
  },
  modules: {
    dashboard_access: true,
    orders_access: true,
    returns_access: true,
    locations_access: true,
    users_access: true,
    settings_access: true,
    order_settings_access: true,
    customer_settings_access: true,
    appointments_access: true,
    unified_stock_access: false,
    reception_access: false,
    logs_access: false,
    parsed_files_access: false,
    catalog_access: false,
    templates_manager_access: false,
    parsings_history_access: false,
    analytics_access: false,
    lookbook_manager_access: false,
    carriers_access: false,
    digital_in_store_access: {
      enabled: false,
      open_in_panel: false,
      additional_services_access: false,
      configuration_manager_access: false,
    },
    octipas_catalog_access: {
      enabled: false,
    },
    tasks_access: false,
    coheris_access: {
      enabled: false,
    },
    checkout_tunnel_access: false,
  },
  font: 'lato',
  partner_logo: null,
}
